import React from "react";
import { NavLink } from "react-router-dom";

export const BaseButton = ({
  as = "button",
  to = "/",
  type = "button",
  disabled = false,
  className = "",
  onClick,
  children,
  ...props
}) => {
  if (as === "link") {
    return (
      <NavLink to={to} className={className} {...props}>
        {children}
      </NavLink>
    );
  }

  return (
    <button
      type={type}
      className={className}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default BaseButton;
